import { theme } from '@drone-js/theme-agoda';
import { theme as theme$b } from '@drone-js/theme-ana';
import { theme as theme$a } from '@drone-js/theme-citi-us';
import { theme as theme$e } from '@drone-js/theme-club-premier';
import { theme as theme$d } from '@drone-js/theme-club-travel';
import { theme as theme$g } from '@drone-js/theme-japanican';
import { theme as theme$8 } from '@drone-js/theme-krisflyer';
import { theme as theme$9 } from '@drone-js/theme-lifemiles';
import { theme as theme$c } from '@drone-js/theme-lotte';
import { theme as theme$f } from '@drone-js/theme-priceline';
import { theme as theme$1 } from '@drone-js/theme-rocketmiles';
import { theme as theme$h } from '@drone-js/theme-rurubu';
import { theme as theme$6 } from '@drone-js/theme-travel1myrewardsaccess';
import { theme as theme$5 } from '@drone-js/theme-travel2myrewardsaccess';
import { theme as theme$4 } from '@drone-js/theme-travel3myrewardsaccess';
import { theme as theme$3 } from '@drone-js/theme-travel4myrewardsaccess';
import { theme as theme$7 } from '@drone-js/theme-usbank';
import { theme as theme$2 } from '@drone-js/theme-westjet';
import { WhiteLabelIds } from './themeProviderInterface.js';

var adsThemeProvider = function adsThemeProvider(whitelabel) {
  if (!whitelabel) {
    return theme;
  }
  switch (whitelabel.theme) {
    case 'theme-rurubu':
      return theme$h;
    case 'theme-japanican':
    case 'theme-spwl':
      return theme$g;
    case 'theme-priceline':
      return theme$f;
    case 'theme-clubpremier':
      return theme$e;
    case 'theme-clubtravel':
      return theme$d;
    case 'theme-lottedfs':
      return theme$c;
    case 'theme-ana':
      return theme$b;
    case 'theme-citius':
      return theme$a;
    case 'theme-lifemiles':
      return theme$9;
    case 'theme-krisflyer':
      return theme$8;
    case 'theme-usbank':
      return theme$7;
    case 'theme-travel1myrewardsaccess':
      return theme$6;
    case 'theme-travel2myrewardsaccess':
      return theme$5;
    case 'theme-travel3myrewardsaccess':
      return theme$4;
    case 'theme-travel4myrewardsaccess':
      return theme$3;
    case 'theme-westjet':
      return theme$2;
    case 'theme-rocketmiles':
      return theme$1;
    case 'theme-agoda':
    case 'theme-jtb':
    default:
      return theme;
  }
};
var whitelabelThemeProvider = function whitelabelThemeProvider(whiteLabelId) {
  switch (whiteLabelId) {
    case WhiteLabelIds.Agoda:
      return theme;
    case WhiteLabelIds.Japanican:
    case WhiteLabelIds.JapanicanUat:
      return theme$g;
    case WhiteLabelIds.Rurubu:
    case WhiteLabelIds.RurubuUat:
      return theme$h;
    case WhiteLabelIds.ANA:
      return theme$b;
    case WhiteLabelIds.CitiUS:
    case WhiteLabelIds.CitiUSUat1:
    case WhiteLabelIds.CitiUSUat2:
    case WhiteLabelIds.CitiUSUat3:
      return theme$a;
    case WhiteLabelIds.LifeMiles:
      return theme$9;
    case WhiteLabelIds.ClubTravel:
      return theme$d;
    case WhiteLabelIds.ClubPremier:
      return theme$e;
    case WhiteLabelIds.LotteDFS:
      return theme$c;
    case WhiteLabelIds.Priceline:
      return theme$f;
    case WhiteLabelIds.KrisFlyer:
      return theme$8;
    case WhiteLabelIds.USBank:
    case WhiteLabelIds.USBankUat1:
      return theme$7;
    case WhiteLabelIds.Travel1MyRewardsAccess:
    case WhiteLabelIds.Travel1MyRewardsAccessUat1:
      return theme$6;
    case WhiteLabelIds.Travel2MyRewardsAccess:
    case WhiteLabelIds.Travel2MyRewardsAccessUat1:
      return theme$5;
    case WhiteLabelIds.Travel3MyRewardsAccess:
    case WhiteLabelIds.Travel3MyRewardsAccessUat1:
      return theme$4;
    case WhiteLabelIds.Travel4MyRewardsAccess:
    case WhiteLabelIds.Travel4MyRewardsAccessUat1:
      return theme$3;
    case WhiteLabelIds.WestJet:
    case WhiteLabelIds.WestJetUat1:
      return theme$2;
    case WhiteLabelIds.Rocketmiles:
    case WhiteLabelIds.RocketmilesUat:
      return theme$1;
    default:
      return theme;
  }
};

export { adsThemeProvider, whitelabelThemeProvider };
//# sourceMappingURL=themeProvider.js.map
